import React, { useEffect, useState } from "react";
import axios from "axios";
import AbsoluteLoaderContainer from "../../components/Loaders/AbsoluteLoaderContainer";
import injectSheet from "react-jss";
import { Forwardbutton, Linkbutton } from "../../components/Buttons";
import ErrorBanner from "../../components/Banners/ErrorBanner";
import EditCheckboxElement from "../../components/edit-element/EditCheckboxElement";
import EditTextElement from "../../components/edit-element/EditTextElement";
import { isMicrosoft } from "../../utils/CheckIf";
import ContactModal from "./ContactModal";
import { sentryAPICatch } from "../../utils/sentryAPICatch";

const informations = [
  {
    property: "username",
    info: "Ange personnummer, samordningsnummer eller dossiernummer(lmanummer)",
  },
];
const label = "person-/lma-nummer";

const Login = (props) => {
  const { location, code, classes } = props;

  const [user, setUser] = useState({
    username: "",
    password: "",
    rememberme: false,
    errormessage: "",
    resetPasswordType: 0,
  });
  const [error, setError] = useState(null);
  const [showLoginForm, setShowLoginForm] = useState(true);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showSupport, setShowSupport] = useState(false);

  useEffect(() => {
    if (
      location &&
      location.pathname &&
      location.pathname === "/logout/expired"
    ) {
      setError("Utloggad på grund av inaktivitet");
    } else if (isMicrosoft.InternetExplorer()) {
      setError(
        "Du bör använda en annan webbläsare. Etjänsten stödjer inte Internet Explorer."
      );
    }
  }, [location.pathname]);

  const handleValueChanged = (e) => {
    if (e.target.name === "username") {
      if (e.target.value.length > 0 && !e.target.value.match(/^[0-9]{1,12}$/g))
        return;
    }
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccess(null);
    const options = {
      method: "POST",
      data: user,
      url: showLoginForm ? "/api/account/login" : "/api/open/reset",
    };

    axios(options)
      .then((res) => {
        const d = res.data;
        if (d.errormessage) {
          if (d.errormessage.includes("[support]")) {
            d.errormessage = d.errormessage.replace("[support]", "");
            setShowSupport(true);
          } else {
            if (showSupport) {
              setShowSupport(false);
            }
          }
          setError(d.errormessage);
          setIsLoading(false);
        } else {
          if (d && !showLoginForm) {
            setIsLoading(false);
          }
          
          if (showLoginForm) {
            props.handleLogin(JSON.parse(d.user));
          } else {
            if (d) {
              setSuccess(
                "Vi har skickat ett meddelande till\n" +
                  d +
                  "\nmed ditt nya lösenord"
              );
              setShowLoginForm(true);
            }
          }
        }
      })
      .catch((error) => {
        sentryAPICatch(error, options.url);
        setError("Ett problem uppstod, vänligen försök igen.");
        setIsLoading(false);
        console.log("Request failed", error);
      });
  };

  const disabled = showLoginForm
    ? !user.username || !user.password
    : !user.username;
  const logo = getlogoProps(code);

  return isLoading ? (
    <AbsoluteLoaderContainer
      totalCenter
      title={showLoginForm ? "Loggar in" : "Återställer lösenord"}
    />
  ) : (
    <div className={classes.container}>
      <div className={classes.content}>
        <div style={{ margin: "2em auto" }}>
          <img src={logo.url} alt="Logo" style={logo.width} />
        </div>
        {showLoginForm && <h1>Välkommen!</h1>}

        <div
          style={{ marginTop: "10px", fontSize: "16px" }}
          className="form-group"
        >
          {showLoginForm
            ? "Vänligen logga in."
            : "Skriv in ditt " + label + " så skickar vi ett nytt lösenord."}
        </div>
        {error && (
          <ErrorBanner>
            {error}
            {showSupport && <ContactModal />}
          </ErrorBanner>
        )}
        {success && (
          <div style={{ color: "green" }}>
            {success
              .split("\n")
              .map((item) =>
                item.split(",").map((x, i) => <div key={i}>{x}</div>)
              )}
          </div>
        )}
        <form onSubmit={handleLogin}>
          <EditTextElement
            label={"Ange " + label}
            id="username"
            name="username"
            cy_id="username-input"
            value={user.username}
            className={classes.inputField}
            handleEventChange={handleValueChanged}
            informations={informations}
            placeholder="ÅÅÅÅMMDDXXXX"
          />
          {showLoginForm ? (
            <div className="form-group">
              <label>Ange lösenord</label>
              <input
                className="form-control"
                type="password"
                name="password"
                data-cy="password-input"
                onChange={handleValueChanged}
              />
            </div>
          ) : (
            <div className={classes.sendVia}>
              <EditCheckboxElement
                checked={user.resetPasswordType === 0}
                inline
                inlineLabel
                labels={["E-post", "SMS"]}
                label="Skicka via"
                handleEventChange={(e) =>
                  setUser({
                    ...user,
                    resetPasswordType: e.target.value === "true" ? 0 : 1,
                  })
                }
              />
            </div>
          )}
          <div
            className="form-group"
            style={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Forwardbutton cy_id="submit-btn" disabled={disabled} type="submit">
              {showLoginForm ? "Logga in" : "Skicka"}
            </Forwardbutton>
          </div>
          <div className="form-group">
            <Linkbutton
              onClick={(e) => {
                setShowLoginForm(!showLoginForm);
                setError(null);
                e.preventDefault();
              }}
            >
              {showLoginForm ? "Glömt lösenord?" : "Tillbaka"}
            </Linkbutton>
          </div>
        </form>
      </div>
    </div>
  );
};
Login.displayName = "Login";

function getlogoProps(code) {
  const url = "/content/customer/" + code + "/" + code + ".png";
  switch (code) {
    case 0: //gustav
    case 1: //ABF
    case 2: //bilda
    case 3: //FU
    case 5: //stfr
    case 8: //nbv
      return { code: code, width: { width: "180px" }, url: url };
    case 7: //sv
    case 10: //mbs
    case 11: //sensus
    case 15: //kulturens
      return {
        code: code,
        width: { width: "40%" },
        url: url,
      };
    case 14: //ibn
      return { code: code, width: { width: "250px" }, url: url };
    default:
      return { code: 0, width: { width: "180px" }, url: url };
  }
}

const styles = {
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  inputField: {
    fontFamily: "sans-serif",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  sendVia: {
    "& .form-group": {
      justifyContent: "center",
      "& div>label": {
        margin: 0,
      },
      "& div>label:first-child": {
        paddingRight: "10px",
      },
    },
  },
  info: {
    marginLeft: "10px",
    "& svg": {
      display: "block",
    },
  },
  content: {
    width: "452px",
    backgroundColor: "white",
    padding: "49px 49px 52px 49px",
    textAlign: "center",
    boxShadow: "0 4px 18px 0 rgba(211, 211, 211, 0.5)",
    "& label": {
      textAlign: "left",
    },
    "& a": {
      fontSize: "14px",
      cursor: "pointer",
    },
    "& img": {
      verticalAlign: "top",
      animation: "$fadein 2s",
      padding: 0,
      margin: 0,
    },
    "& form": {
      width: "70%",
      margin: "28px auto 0 auto",
    },
  },
  "@media (max-width: 1023px)": {
    container: {
      width: "100%",
      height: "100vh",
      backgroundColor: "white",
    },
    content: {
      width: "100%",
      height: "auto",
      boxShadow: "unset",
      padding: "49px 49px 52px 49px",
      textAlign: "center",
      "& label": {
        textAlign: "left",
      },
      "& a": {
        fontSize: "14px",
      },
      "& form": {
        width: "80%",
        margin: "59px auto 0 auto",
      },
    },
  },
};
export default injectSheet(styles)(Login);
